export default __webpack_public_path__ + "static/media/IND-2.7a0c97a3.jpg";